import React, {createContext, useContext} from "react"
import {useTranslation} from "react-i18next"
import {ProgressIndicator} from "../app/ProgressIndicator"

const SettingsTranslationContext = createContext(undefined)

export const SettingsTranslationProvider = ({children}) => {
    const {t, ready} = useTranslation("bpn.settings", {useSuspense: false})

    if (ready) {
        return (
            <SettingsTranslationContext.Provider value={t}>
                {children}
            </SettingsTranslationContext.Provider>
        )
    } else {
        return <ProgressIndicator/>
    }
}

export const useSettingsTranslation = () => {
    return useContext(SettingsTranslationContext)
}